/** Public B2B service price list. The source workbook vendor name is omitted. */

const SALES_EMAIL = 'sales@220-km.com';

const SECTIONS = [
  {
    id: 'onsite',
    rows: [
      { id: 'diagnosticVisit', unit: 'visit', price: '5\u00a0200', note: 'travel60km' },
      { id: 'plannedMaintenance', unit: 'visit', price: '5\u00a0400', note: 'includedInContract' },
      { id: 'urgentVisit', unit: 'visit', price: '7\u00a0200' },
      { id: 'componentReplacement', unit: 'job', price: '5\u00a0400', note: 'partsExtra' },
      { id: 'electricalMeasurements', unit: 'package', price: '6\u00a0600', note: 'groundingInsulation' },
    ],
  },
  {
    id: 'install',
    rows: [
      { id: 'dismantleUpTo60', unit: 'job', price: '7\u00a0200' },
      { id: 'dismantleOver60', unit: 'job', price: '8\u00a0400' },
      { id: 'installUpTo60', unit: 'job', price: '12\u00a0600' },
      { id: 'installOver60', unit: 'job', price: '14\u00a0400' },
      { id: 'replaceUpTo60', unit: 'package', price: '18\u00a0000', note: 'oneVisitCheaper' },
      { id: 'replaceOver60', unit: 'package', price: '21\u00a0600', note: 'oneVisitCheaper' },
      { id: 'commissioning', unit: 'package', price: '14\u00a0400' },
      { id: 'crane', unit: 'visit', priceKey: 'asIncurred', note: 'craneFrom5000' },
    ],
  },
  {
    id: 'extra',
    rows: [{ id: 'over60km', unit: 'perKm', price: '24', note: 'perKmBothWays' }],
  },
  {
    id: 'packages',
    rows: [
      { id: 'annualUpTo60', unit: 'perMonth', price: '2\u00a0200', note: 'annualUpTo60' },
      { id: 'annualOver60', unit: 'perMonth', price: '3\u00a0000' },
    ],
  },
];

const COPY = {
  ua: {
    subtitle: 'Прайс-лист сервісних послуг для зарядних станцій',
    effective: 'Чинний з 12 вересня 2026 р. Ціни вказані в гривнях з ПДВ.',
    columns: {
      service: 'Послуга',
      unit: 'Од. виміру',
      price: 'Ціна, грн з ПДВ',
      note: 'Примітка',
    },
    sectionTitles: {
      onsite: 'Виїзні роботи',
      install: 'Монтаж, демонтаж, заміна станцій',
      extra: 'Додатково',
      packages: 'Сервісні пакети',
    },
    units: {
      visit: 'виїзд',
      job: 'робота',
      package: 'комплекс',
      perKm: 'грн/км',
      perMonth: 'грн/міс',
    },
    priceLabels: {
      asIncurred: 'за фактом',
    },
    services: {
      diagnosticVisit: 'Діагностичний виїзд',
      plannedMaintenance: 'Планове технічне обслуговування станції DC (за регламентом виробника, з чек-листом)',
      urgentVisit: 'Терміновий виїзд (початок робіт протягом 24–48 годин)',
      componentReplacement: 'Заміна вузла або компонента, дрібний ремонт (обжим, фарбування сколу тощо)',
      electricalMeasurements: 'Електротехнічні вимірювання з офіційним протоколом',
      dismantleUpTo60: 'Демонтаж станції DC до 60 кВт',
      dismantleOver60: 'Демонтаж станції DC понад 60 кВт',
      installUpTo60: 'Монтаж і підключення станції DC до 60 кВт',
      installOver60: 'Монтаж і підключення станції DC понад 60 кВт',
      replaceUpTo60: 'Заміна станції на локації DC до 60 кВт',
      replaceOver60: 'Заміна станції на локації DC понад 60 кВт',
      commissioning: 'Пуско-налагоджувальні роботи (ПНР) нової станції',
      crane: 'Послуги маніпулятора/автокрана (якщо демонтаж або монтаж неможливо зробити роклою)',
      over60km: 'Виїзд понад 60 км від Києва',
      annualUpTo60: 'Річний договір ТО: станція DC до 60 кВт',
      annualOver60: 'Річний договір ТО: станція DC понад 60 кВт',
    },
    notes: {
      travel60km: 'включає дорогу в радіусі 60 км від Києва',
      includedInContract: 'для станцій на договорі ТО — у складі договору',
      partsExtra: 'без вартості запасних частин',
      groundingInsulation: 'заземлення, опір ізоляції',
      oneVisitCheaper: 'демонтаж старої та монтаж нової за один виїзд; вигідніше, ніж окремі демонтаж і монтаж',
      craneFrom5000: 'орієнтовно від 5\u00a0000 грн; погоджується до початку робіт',
      perKmBothWays: 'за 1 км відстані; дорога в обидва боки вже врахована в тарифі',
      annualUpTo60:
        '2 планових ТО на рік, пріоритетний виїзд (SLA 48 год, але не частіше 1 раза на 2 міс., інше — SLA 96 год), знижка 25% на аварійні роботи. Не включає вартість запчастин — лише планові роботи в межах ТО.',
    },
    conditionsTitle: 'Умови надання послуг',
    conditions: [
      'Усі ціни вказані в гривнях з ПДВ, якщо не зазначено інше.',
      'Запасні частини та матеріали оплачуються окремо і погоджуються із замовником до початку робіт.',
      'Перенесення станції на іншу локацію тарифікується як окремі демонтаж і монтаж (дві позиції прайсу).',
      'Роботи по станціях виробника в межах гарантійного строку виконуються безкоштовно згідно з гарантійними умовами, компоненти — безкоштовно (окрім вандалізму та пошкодження третіми особами).',
      'На виконані роботи надається гарантія 6 місяців.',
      'Стан станцій контролюється службою моніторингу в режимі 24/7; діагностика виконується сертифікованими фахівцями з використанням оригінальних запасних частин.',
    ],
    validThrough: 'Строк дії цін — до 31.12.2026. Актуальність цін:',
  },
  ru: {
    subtitle: 'Прайс-лист сервисных услуг для зарядных станций',
    effective: 'Действует с 12 сентября 2026 г. Цены указаны в гривнах с НДС.',
    columns: {
      service: 'Услуга',
      unit: 'Ед. изм.',
      price: 'Цена, грн с НДС',
      note: 'Примечание',
    },
    sectionTitles: {
      onsite: 'Выездные работы',
      install: 'Монтаж, демонтаж, замена станций',
      extra: 'Дополнительно',
      packages: 'Сервисные пакеты',
    },
    units: {
      visit: 'выезд',
      job: 'работа',
      package: 'комплекс',
      perKm: 'грн/км',
      perMonth: 'грн/мес',
    },
    priceLabels: {
      asIncurred: 'по факту',
    },
    services: {
      diagnosticVisit: 'Диагностический выезд',
      plannedMaintenance: 'Плановое техническое обслуживание станции DC (по регламенту производителя, с чек-листом)',
      urgentVisit: 'Срочный выезд (начало работ в течение 24–48 часов)',
      componentReplacement: 'Замена узла или компонента, мелкий ремонт (обжим, подкраска скола и т. п.)',
      electricalMeasurements: 'Электротехнические измерения с официальным протоколом',
      dismantleUpTo60: 'Демонтаж станции DC до 60 кВт',
      dismantleOver60: 'Демонтаж станции DC свыше 60 кВт',
      installUpTo60: 'Монтаж и подключение станции DC до 60 кВт',
      installOver60: 'Монтаж и подключение станции DC свыше 60 кВт',
      replaceUpTo60: 'Замена станции на локации DC до 60 кВт',
      replaceOver60: 'Замена станции на локации DC свыше 60 кВт',
      commissioning: 'Пусконаладочные работы новой станции',
      crane: 'Услуги манипулятора/автокрана (если демонтаж или монтаж нельзя выполнить рохлей)',
      over60km: 'Выезд свыше 60 км от Киева',
      annualUpTo60: 'Годовой договор ТО: станция DC до 60 кВт',
      annualOver60: 'Годовой договор ТО: станция DC свыше 60 кВт',
    },
    notes: {
      travel60km: 'включает дорогу в радиусе 60 км от Киева',
      includedInContract: 'для станций на договоре ТО — в составе договора',
      partsExtra: 'без стоимости запасных частей',
      groundingInsulation: 'заземление, сопротивление изоляции',
      oneVisitCheaper: 'демонтаж старой и монтаж новой за один выезд; выгоднее, чем отдельные демонтаж и монтаж',
      craneFrom5000: 'ориентировочно от 5\u00a0000 грн; согласовывается до начала работ',
      perKmBothWays: 'за 1 км расстояния; дорога в обе стороны уже учтена в тарифе',
      annualUpTo60:
        '2 плановых ТО в год, приоритетный выезд (SLA 48 ч, но не чаще 1 раза в 2 мес., иначе — SLA 96 ч), скидка 25% на аварийные работы. Не включает стоимость запчастей — только плановые работы в рамках ТО.',
    },
    conditionsTitle: 'Условия предоставления услуг',
    conditions: [
      'Все цены указаны в гривнах с НДС, если не указано иное.',
      'Запасные части и материалы оплачиваются отдельно и согласовываются с заказчиком до начала работ.',
      'Перенос станции на другую локацию тарифицируется как отдельные демонтаж и монтаж (две позиции прайса).',
      'Работы по станциям производителя в пределах гарантийного срока выполняются бесплатно согласно гарантийным условиям, компоненты — бесплатно (кроме вандализма и повреждения третьими лицами).',
      'На выполненные работы предоставляется гарантия 6 месяцев.',
      'Состояние станций контролируется службой мониторинга в режиме 24/7; диагностика выполняется сертифицированными специалистами с использованием оригинальных запасных частей.',
    ],
    validThrough: 'Срок действия цен — до 31.12.2026. Актуальность цен:',
  },
  en: {
    subtitle: 'Service price list for charging stations',
    effective: 'Effective 12 September 2026. Prices are in hryvnia and include VAT.',
    columns: {
      service: 'Service',
      unit: 'Unit',
      price: 'Price, UAH incl. VAT',
      note: 'Note',
    },
    sectionTitles: {
      onsite: 'On-site work',
      install: 'Installation, removal, replacement',
      extra: 'Extra',
      packages: 'Service packages',
    },
    units: {
      visit: 'visit',
      job: 'job',
      package: 'package',
      perKm: 'UAH/km',
      perMonth: 'UAH/month',
    },
    priceLabels: {
      asIncurred: 'as incurred',
    },
    services: {
      diagnosticVisit: 'Diagnostic visit',
      plannedMaintenance: 'Scheduled DC station maintenance (manufacturer checklist)',
      urgentVisit: 'Urgent visit (work starts within 24–48 hours)',
      componentReplacement: 'Replacing a unit or component, minor repair (crimping, touch-up paint, and similar)',
      electricalMeasurements: 'Electrical measurements with an official protocol',
      dismantleUpTo60: 'Removal of a DC station up to 60 kW',
      dismantleOver60: 'Removal of a DC station above 60 kW',
      installUpTo60: 'Installation and connection of a DC station up to 60 kW',
      installOver60: 'Installation and connection of a DC station above 60 kW',
      replaceUpTo60: 'Replacing a DC station on site, up to 60 kW',
      replaceOver60: 'Replacing a DC station on site, above 60 kW',
      commissioning: 'Commissioning of a new station',
      crane: 'Manipulator or crane, when a pallet jack cannot do the removal or installation',
      over60km: 'Travel beyond 60 km from Kyiv',
      annualUpTo60: 'Annual maintenance contract: DC station up to 60 kW',
      annualOver60: 'Annual maintenance contract: DC station above 60 kW',
    },
    notes: {
      travel60km: 'includes travel within 60 km of Kyiv',
      includedInContract: 'included in the maintenance contract',
      partsExtra: 'spare parts not included',
      groundingInsulation: 'grounding and insulation resistance',
      oneVisitCheaper:
        'removal of the old station and installation of the new one in one visit; cheaper than separate removal and installation',
      craneFrom5000: 'about 5,000 UAH and up; agreed before work starts',
      perKmBothWays: 'per 1 km; the round trip is already included in the rate',
      annualUpTo60:
        '2 scheduled maintenance visits a year, priority call-out (SLA 48 hours, no more than once every 2 months; otherwise SLA 96 hours), 25% off emergency work. Spare parts are not included — only scheduled maintenance work.',
    },
    conditionsTitle: 'Terms of service',
    conditions: [
      'All prices are in hryvnia and include VAT, unless stated otherwise.',
      'Spare parts and materials are paid separately and agreed with the customer before work starts.',
      'Moving a station to another site is priced as separate removal and installation (two price-list items).',
      'Work on the manufacturer stations within the warranty period is free under the warranty terms. Components are free, except vandalism and damage by third parties.',
      'Completed work is covered by a 6-month warranty.',
      'Station status is monitored 24/7. Diagnostics are performed by certified specialists using original spare parts.',
    ],
    validThrough: 'Prices are valid through 31 December 2026. Current prices:',
  },
};

function resolveCopy(dict) {
  return {
    subtitle: dict.subtitle,
    effective: dict.effective,
    columns: dict.columns,
    conditionsTitle: dict.conditionsTitle,
    conditions: dict.conditions,
    validThrough: dict.validThrough,
    salesEmail: SALES_EMAIL,
    sections: SECTIONS.map(section => ({
      id: section.id,
      title: dict.sectionTitles[section.id],
      rows: section.rows.map(row => ({
        id: row.id,
        service: dict.services[row.id],
        unit: dict.units[row.unit],
        price: row.priceKey ? dict.priceLabels[row.priceKey] : row.price,
        note: row.note ? dict.notes[row.note] : '',
      })),
    })),
  };
}

export function getB2bServicePriceCopy(language) {
  const lang = String(language || 'ua').toLowerCase();
  if (lang.startsWith('en')) return resolveCopy(COPY.en);
  if (lang.startsWith('ru')) return resolveCopy(COPY.ru);
  return resolveCopy(COPY.ua);
}

export const B2B_SERVICE_PRICE_COPY = COPY;
